import { MAX_ANSWER_FIELD_LENGTH } from "features/Library/Common/constants";
import InputField from "features/Library/Common/Fields/InputField";
import { WithFormikPayload } from "features/Library/Common/Fields/WithFormikPayload";
import styles from "./TextAnswer.module.scss";
import { type AnswerPropsBase } from "features/Library/Common/QuestionsForm/types";
import React from "react";
import CheckboxField from "features/Library/Common/Fields/CheckboxField";

export type TextAnswerProps = Omit<AnswerPropsBase<string>, "answer" | "propertyNamePrefix"> & {
  answer: string;
  answerFieldPropertyName: string;
  isChecked?: boolean;
  checkboxFieldPropertyName?: string;
  pathToValidate?: string;
  radio?: boolean;
  id?: string;
};

export const TextAnswer = (props: TextAnswerProps) => {
  const {
    index,
    answer,
    onBlur,
    disabled,
    validatedFieldProps,
    answerFieldPropertyName,
    checkboxFieldPropertyName,
    isChecked,
    onChanged,
    radio = false,
    pathToValidate,
    id,
  } = props;

  const { setFieldValue, setFieldTouched } = validatedFieldProps;

  return (
    <div className={styles.container}>
      {checkboxFieldPropertyName && (
        <WithFormikPayload
          propertyName={checkboxFieldPropertyName}
          {...validatedFieldProps}
          pathToValidate={pathToValidate}
          render={(formikProps) => (
            <CheckboxField
              id={id}
              radio={radio}
              disableValidation={!pathToValidate}
              withoutErrorMessage
              index={index}
              value={!!isChecked}
              disabled={disabled}
              onChange={onChanged}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              {...formikProps}
            />
          )}
        />
      )}
      <div className={styles.text}>
        <WithFormikPayload
          propertyName={answerFieldPropertyName}
          {...validatedFieldProps}
          selfValidation
          render={(formikProps) => (
            <InputField
              placeholder={`Answer ${index + 1}`}
              value={answer}
              maxLength={MAX_ANSWER_FIELD_LENGTH}
              errorPosition={"bottom"}
              onBlur={onBlur}
              disabled={disabled}
              setFieldTouched={setFieldTouched}
              setFieldValue={setFieldValue}
              {...formikProps}
            />
          )}
        />
      </div>
    </div>
  );
};
